import React from 'react';
import { ArrowDownIcon, StarIcon } from 'lucide-react';
import { PhotoPlaceholder } from './PhotoPlaceholder';
import { BookButton } from './BookButton';
import { Reveal } from './Reveal';
export function Hero() {
  return <section aria-labelledby="hero-heading" className="relative flex min-h-[100svh] items-center overflow-hidden bg-navy pb-20 pt-32 md:pt-36" data-id="element-96" data-mp="9ll8gva8vumg">
      <div className="absolute inset-0" data-id="element-97" data-mp="1297ahz3tqr77">
        <PhotoPlaceholder variant="background" src="https://cdn.magicpatterns.com/patterns/generated-images/ac2d1a85-d8eb-4afe-b592-4772e2515e3e.jpg" description="Homecoming in a front yard" alt="A service member in a plain utility uniform kneels in a front yard to hug a young child running into their arms, as a spouse looks on in late-afternoon light." supplySize="2880 × 1800 px or larger" className="hero-zoom object-[75%_center]" data-id="element-98" data-mp="1285wpmvfbqls" />
        <div aria-hidden="true" className="absolute inset-0 z-10 bg-navy/80 lg:bg-navy/60" data-id="element-99" data-mp="380vznzu8sxe7" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-10" data-id="element-100" data-mp="3j9ai9gc8yw6q">
        <Reveal className="max-w-3xl" data-id="element-101" data-mp="3o6ap3tgx82yw">
          <p className="flex items-center gap-3 text-sm font-semibold tracking-[0.2em] text-gold" data-id="element-102" data-mp="3o59dnnvztegn">
            <StarIcon aria-hidden="true" className="h-4 w-4 fill-gold text-gold" strokeWidth={1} data-id="element-103" data-mp="39cpc2rohrf1b" />
            VETERAN OWNED. VETERAN RUN.
          </p>
          <h1 id="hero-heading" className="mt-6 font-serif text-5xl font-semibold leading-[1.08] text-paper md:text-6xl lg:text-7xl" data-id="element-104" data-mp="30gzvcvxzn8u9">
            You earned it. We'll help you claim it.
          </h1>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-paper/85 md:text-xl" data-id="element-105" data-mp="2qhqudj4pgtye">
            Trusted by fellow vets. Built by those who've been there. We sit down with you, hear your whole
            story, and guide you through the VA disability process step by step.
          </p>

          <div className="mt-10 flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:gap-8" data-id="element-106" data-mp="2ljz0wkoewzs3">
            <BookButton data-id="element-107" data-mp="s44gvk8yvfgb" />
            <a href="#how-it-works" className="inline-flex min-h-[48px] items-center gap-2 text-lg font-medium text-paper underline decoration-gold/70 underline-offset-[6px] transition-colors duration-150 ease-out hover:text-gold" data-id="element-108" data-mp="nbba6qtxtx1l">
              See how it works
              <ArrowDownIcon aria-hidden="true" className="h-5 w-5" data-id="element-109" data-mp="1b0ni7ndj3z2b" />
            </a>
          </div>

          <p className="mt-8 text-lg text-paper/90" data-id="element-110" data-mp="1622jxthu7pgi">
            No pressure. No call center. A veteran on the other end of the line.
          </p>
        </Reveal>
      </div>
    </section>;
}